module.exports = __webpack_public_path__ + "media/images/logo-ukri-9224c0a311c7602adba10d2430b35ce1.svg";